import { atom } from 'recoil';
import { Cashback, CashbackInfoResponse } from '@/types/api/mypage/cashbackInfo';
import persistAtom from './recoilPersist';

/** キャッシュバック情報の初期値（空のキャンペーンリスト） */
const campaignList: Cashback[] = [];

/**
 * キャッシュバック情報のステート
 * キャッシュバック受取状況や受取期限などの情報を保持する。
 */
export const CashbackInfoState = atom<CashbackInfoResponse>({
  key: 'CashbackInfoState',
  default: {
    cashback_list: campaignList,
  },
  effects_UNSTABLE: [persistAtom],
});

export default CashbackInfoState;
